import { adminConstants } from "../constant/admin-constant";

const initialState = {
    loadingItem : false,
    items : []
}

export const itemReducer = (state = initialState, action) => {
    switch (action.type) {

        case adminConstants.GET_ITEMS_REQUEST:
            return { ...state, loadingItem: true};
        case adminConstants.GET_ITEMS_SUCCESS:
            return { ...state, loadingItem:false, items:action.payload.items };
        case adminConstants.GET_ITEMS_FAILURE:
            return { ...state, loadingItem:false, error:action.payload };

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/ItemReducer.jsx